import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["open", "suggestedAddresses", "selectedAddress", "manualAddress", "onSelect", "onConfirm"];
import React from 'react';
import { Button, Form, Message, Radio } from 'semantic-ui-react';
import { SUGGESTED_ADDRESSES_FOUND_TEXT, SUGGESTED_ADDRESSES_HELP_TEXT } from './AddressSuggestionsDisplay.constants';
import { LocationAddressPropType } from '../../../../../../services/proptypes';
import { stringifyAddress } from '../../../../../../utils/address';
import Modal from '../../../../../foundation/components/Modal';
import useSemanticUiProps from '../../../../../foundation/hooks/use-semantic-ui-props';
import AddressEnteredDisplay from '../AddressEnteredDisplay';
function AddressSuggestionsDisplay(_ref) {
  var open = _ref.open,
    suggestedAddresses = _ref.suggestedAddresses,
    selectedAddress = _ref.selectedAddress,
    manualAddress = _ref.manualAddress,
    onSelect = _ref.onSelect,
    onConfirm = _ref.onConfirm,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useSemanticUiProps = useSemanticUiProps(),
    getModalProps = _useSemanticUiProps.getModalProps;
  function handleSelectedAddressChange(e, _ref2) {
    var value = _ref2.value;
    onSelect(value);
  }
  return /*#__PURE__*/React.createElement(Modal, _extends({
    open: open
  }, getModalProps(rest)), /*#__PURE__*/React.createElement(Modal.Header, null, "Is this what you meant?"), /*#__PURE__*/React.createElement(Modal.Content, null, /*#__PURE__*/React.createElement("p", null, SUGGESTED_ADDRESSES_FOUND_TEXT), /*#__PURE__*/React.createElement(Message, null, /*#__PURE__*/React.createElement(Form, null, suggestedAddresses.map(function (address) {
    return /*#__PURE__*/React.createElement(Form.Field, {
      key: stringifyAddress(address)
    }, /*#__PURE__*/React.createElement(Radio, {
      label: stringifyAddress(address),
      name: "radioGroup",
      value: address,
      checked: selectedAddress === address,
      onChange: handleSelectedAddressChange
    }));
  }))), /*#__PURE__*/React.createElement(AddressEnteredDisplay, {
    address: manualAddress
  }), /*#__PURE__*/React.createElement("p", null, SUGGESTED_ADDRESSES_HELP_TEXT)), /*#__PURE__*/React.createElement(Modal.Actions, null, /*#__PURE__*/React.createElement(Button, {
    onClick: onConfirm
  }, "Confirm")));
}
export default AddressSuggestionsDisplay;